import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Container,
  FormGroup,
  Form,
  Input,
  Label,
  Row,
  Col,
} from "reactstrap";
import statesModel from "models/states.model";
import { helper } from "lib/helper";
import axios from "axios";
import parentsModal from "models/parents.modal";
import tutorsModal from "models/tutors.modal";
import classModal from "models/class.modal";
import moment from "moment";
import enquiriesModal from "models/enquiries.modal";

const label = { inputProps: { "aria-label": "Checkbox demo" } };
const AddClassesbyid = () => {
  const parms = useParams();
  // add row in staudent and subject add multipal row
  const [rowData, setRowData] = useState([[]]);
  const addRow = () => {
    setRowData((prevData) => [...prevData, []]);
  };
  const deleteRow = (index) => {
    setRowData((prevData) => {
      const newData = [...prevData];
      newData.splice(index, 1);
      return newData;
    });
  };
  console.log("addd--------", parms);
  // all state get api
  const [stateList, setSatateList] = useState([]);
  const getListAllState = async () => {
    await statesModel
      .listState()
      .then((result) => {
        if (result) {
          setSatateList(result?.results);
        }
      })
      .catch((error) => {
        helper.sweetalert.toast(error.response?.data?.message, "warning");
      });
  };
  useEffect(() => {
    getListAllState();
  }, []);

  // handleselect state  get id function
  const [selectedStateId, setSelectedStateId] = useState("");
  const [selectedName, setSelectedName] = useState("");
  const handleChange = (event) => {
    // Get the selected option
    const selectedOption = event.target.options[event.target.selectedIndex];
    // Update the state variables with the ID and name
    setSelectedStateId(selectedOption.value);
    getListAllCity(selectedOption.value);
    setSelectedName(selectedOption.text);
  };

  // all city get api in state id baises
  const [cityList, setCityList] = useState([]);
  const getListAllCity = async (id) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/studentapi/city/?state=${id}`
      );
      setCityList(response.data.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // parent list get in all parents get
  const [parentsList, setParentsList] = useState([]);
  const getListDataParents = async () => {
    await parentsModal
      .ParentlistallData()
      .then((result) => {
        if (result) {
          setParentsList(result?.data);
        }
      })
      .catch((error) => {
        helper.sweetalert.toast(error.response?.data?.message, "warning");
      });
  };

  useEffect(() => {
    getListDataParents();
  }, []);

  // parent select function and get mobile no.
  const [selectedParentsId, setSelectedParentsId] = useState("");
  const handleChangeParents = (event) => {
    // Get the selected option

    // Update the state variables with the ID and name
    setSelectedParentsId(parms?.id);
    getListDataByidStudent(parms?.id);
  };
  console.log("ddddd", selectedParentsId);
  useEffect(() => {
    handleChangeParents();
  }, []);
  // All tutors get api
  const [tutorsList, setTotursList] = useState([]);
  const getListDataTutors = async () => {
    await tutorsModal
      .tutorslistallData()
      .then((result) => {
        if (result) {
          setTotursList(result.data);
        }
      })
      .catch((error) => {
        helper.sweetalert.toast(error.response?.data?.message, "warning");
      });
  };

  useEffect(() => {
    getListDataTutors();
  }, []);

  // tutors select function
  const [selectedTutorsId, setSelectedTutorsId] = useState("");
  const handleChangeTutors = (event) => {
    // Get the selected option
    const selectedOption = event.target.options[event.target.selectedIndex];
    // Update the state variables with the ID and name
    setSelectedTutorsId(selectedOption.value);
  };

  // classtype change function
  const [selectedClassType, setSelectedClassType] = useState("RuningClass");
  const handleChangeClassType = (event) => {
    // Get the selected option
    const selectedOption = event.target.options[event.target.selectedIndex];
    // Update the state variables with the ID and name
    setSelectedClassType(selectedOption.value);
  };

  // Parent id pass and parent student get
  const [studentList, setStatudentList] = useState([]);
  const getListDataByidStudent = (id) => {
    parentsModal
      .listbyParentidStudentGet(id)
      .then((response) => {
        console.log(response);
        setStatudentList(response.data.data);
      })
      .catch((error) => { });
  };

  // Student select function
  const [studentId, setStudentId] = useState([]);
  const handleStudentSelect = (e, index) => {
    const { value } = e.target;
    setRowData((prevData) => {
      const newData = [...prevData]; // Copy the previous state
      newData[index] = [parseInt(value)]; // Convert the selected value to a number and store it in the rowData array for the current row
      return newData; // Return the updated state
    });
    setStudentId((prevData) => {
      const newData = [...prevData];
      newData[index] = [parseInt(value)]; // Convert the selected value to a number and store it in the rowData array for the current row
      return newData[0]; // Return the updated state
    });
  };

  // Subject select function
  const handleSubjectSelect = (e, rowIndex, subjectId) => {
    const { checked } = e.target;
    setRowData((prevData) => {
      const newData = [...prevData]; // Copy the previous state
      if (!newData[rowIndex]) {
        newData[rowIndex] = []; // Initialize the rowData array for the current row if it doesn't exist
      }
      const updatedRowData = [...newData[rowIndex]]; // Copy the rowData array for the current row
      const subjectIndex = updatedRowData.indexOf(subjectId);
      if (checked && subjectIndex === -1) {
        updatedRowData.push(subjectId); // Add the subjectId to the rowData array if it's checked and not already present
      } else if (!checked && subjectIndex !== -1) {
        updatedRowData.splice(subjectIndex, 1); // Remove the subjectId from the rowData array if it's unchecked and present
      }
      newData[rowIndex] = updatedRowData; // Update the rowData array for the current row in the newData array
      return newData; // Return the updated state
    });
  };

  // student id and subject id conbined one array
  const combinedArray = [];
  rowData.forEach((arr) => {
    combinedArray.push(arr);
  });
  console.log("combined array", combinedArray)
  // pass student id and get all subject in dstudent baises
  const [studentSubjectList, setStatudentSubjectList] = useState([]);
  const getListDataByidStudentSubject = () => {
    parentsModal
      .listbyParentidStudentSubjectGet(studentId)
      .then((response) => {
        console.log(response);
        setStatudentSubjectList(response.data.Subjects);
      })
      .catch((error) => { });
  };
  useEffect(() => {
    getListDataByidStudentSubject();
  }, [studentId]);

  // select start time function
  const [startTime, setStartTime] = useState("");
  const handleStartTimeChange = (event) => {
    const { value } = event.target;
    setStartTime(value); // Update startTime state with the selected time
  };

  // select end time function
  const [endTime, setEndTime] = useState("");
  const handleEndTimeChange = (event) => {
    const { value } = event.target;
    setEndTime(value);
  };

  // select badge function
  const [badge, setBadge] = useState();
  const handleselectbadge = (event) => {
    const { value } = event.target;
    setBadge(value); // Update endTime state with the selected time
  };

  // select city function
  const [selectCityName, setSelectCityName] = useState("");
  const handleChangeCity = (event) => {
    const { value } = event.target;
    setSelectCityName(value);
  };

  // select status function
  const [selecttStatus, setSelectStatus] = useState("");
  const handleChangeStatus = (event) => {
    const { value } = event.target;
    setSelectStatus(value);
  };
  // select mode function
  const [selecttMode, setSelectMode] = useState("");
  const handleChangeMode = (event) => {
    const { value } = event.target;
    setSelectMode(value);
  };
  console.log("selecyted mode", selecttMode)
  const [addsLoadig, setAddsLoadig] = useState(false);

  // class create  filed data in single state
  const [formData, setFormData] = useState({
    name: "",
    number_of_session: "",
    price_parent: 0,
    price_tutor: "0",
    margin: "",
    days: "",
    session_per_month: "0",
    hours: "",
    duration: "",
    demo_link: "",
    discount_price: "",
    monthly_fee: "",
    hourly_fee: "",
    monthly_payscale: "",
    hourly_payscale: "",
    total_cycle: "",
    notes: "",
    fee_details: "0",
    address: "",
    location: "",
  });

  // input valu change in formdata
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value, // Store the value in the state
    }));
    calculateResult(name, value);
  };

  //  parents_price and tutors_price - nad show value in margin
  const calculateMargin = () => {
    const priceParent = parseFloat(formData.price_parent);
    const priceTutor = parseFloat(formData.price_tutor);
    if (!isNaN(priceParent) && !isNaN(priceTutor)) {
      // Check if both values are valid numbers
      return (priceParent - priceTutor).toString(); // Calculate and return the margin as a string
    }
    return ""; // Return an empty string if either value is not a valid number
  };

  // Calculate margin when either "Price Parent" or "Price Tutors" change
  useEffect(() => {
    const margin = calculateMargin();
    setFormData((prevState) => ({
      ...prevState,
      margin: margin,
    }));
  }, [formData.price_parent, formData.price_tutor]);

  // Select week
  const weekNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  // State to store selected week names
  const [selectedWeeks, setSelectedWeeks] = useState([]);

  // Function to handle checkbox change
  const handleCheckboxChange = (weekName) => {
    // Check if the weekName is already selected
    if (selectedWeeks.includes(weekName)) {
      // If selected, remove it from the array
      setSelectedWeeks(selectedWeeks.filter((name) => name !== weekName));
    } else {
      // If not selected, add it to the array
      setSelectedWeeks([...selectedWeeks, weekName]);
    }
  };

  const [meetingDate, setMeetingDate] = useState("");
  const handleDateChange = (event) => {
    const { value } = event.target;
    setMeetingDate(value); // Update meetingDate state with the selected date
  };
  const formattedDate = moment(meetingDate).format("DD/MM/YYYY");

  // Class Create  post api
  const navigate = useNavigate();


  const handleSubmit = (event) => {
    event.preventDefault();
    /* const data = new FormData(event.target);
    console.clear();
    console.log("data ------------> ", combinedArray);
    const starttime = data.get("start_time");
    const endtime = data.get("end_time");
    data.append("start_date", formattedDate)
    data.append("status", "Regular")
    //data.append("students",combinedArray)
    data.set("start_time", moment(starttime, "HH:mm").format("hh:mm A"),)
    data.set("end_time", moment(endtime, "HH:mm").format("hh:mm A"),)

    selectedWeeks.forEach(day => {
      data.append("days[]", day);
    });

    combinedArray.forEach((student, index) => {
      student.forEach((stuData, stuIndex) => {
        data.append(`students[${index}][${stuIndex}]`, stuData);
      });
    }); */
    setAddsLoadig(true);
    event.preventDefault();
    const data = {
      name: formData.name,
      state: parent?.userData?.parentData?.state,
      city: parent?.userData?.parentData?.city,
      location: parent?.userData?.parentData?.location,
      parent: parseInt(selectedParentsId),
      tutor: parseInt(parms?.mid),
      badge: parseInt(badge),
      type: selectedClassType,
      start_time: moment(startTime, "HH:mm").format("hh:mm A"),
      end_time: moment(endTime, "HH:mm").format("hh:mm A"),
      number_of_session: parseInt(formData.number_of_session),
      price_parent: parseInt(formData.price_parent),
      price_tutor: parseInt(formData.price_tutor),
      margin: formData.monthly_fee && formData.monthly_payscale ? formData.monthly_fee - formData.monthly_payscale : 0,
      days: parseInt(formData.days),
      session_per_month: parseInt(formData.number_of_session),
      demo_link: formData.demo_link,
      start_date: formattedDate,
      days: selectedWeeks,
      hours: parseInt(calculatedResult),
      duration: parseInt(formData.duration),
      students: combinedArray,
      mode: selecttMode,
      status: "Regular",
      discount_price: 0,
      monthly_fee: parseInt(formData.monthly_fee),
      hourly_fee: parseInt(formData.monthly_fee &&
        formData.number_of_session &&
        formData.duration
        ? Math.round(
          (formData.monthly_fee /
            (formData.number_of_session *
              formData.duration)) *
          60
        )
        : ""),
      monthly_payscale: parseInt(formData.monthly_payscale),
      hourly_payscale: parseInt(formData.monthly_payscale &&
        formData.number_of_session &&
        formData.duration
        ? Math.round(
          (formData.monthly_payscale /
            (formData.number_of_session *
              formData.duration)) *
          60
        )
        : ""),
      total_cycle: parseInt(formData.total_cycle),
      notes: formData.notes,
      fee_details: formData.fee_details,
      address: formData.address,
    };

    classModal
      .createClass(data)
      .then((response) => {
        setAddsLoadig(false);
        if (!response?.is_error) {
          helper.sweetalert.toast(response.message, "success");
          navigate("/admin/raiseinvoice");
        } else {
          helper.sweetalert.toast(response.message, "warning");
        }

      })
      .catch((error) => {
        setAddsLoadig(false);
        // console.log(error);
      });
  };

  const [totalmintes, setTotalmintes] = useState();

  const [calculatedResult, setCalculatedResult] = useState(0);
  const calculateResult = (name, value) => {
    const newFormData = { ...formData, [name]: value };
    const duration = parseFloat(newFormData.duration) || 0;
    const sessionPerMonth = parseFloat(newFormData.number_of_session) || 0;

    const result = (duration * sessionPerMonth) / 60;
    const totalmin = duration * sessionPerMonth;
    setTotalmintes(totalmin);

    setCalculatedResult(result.toFixed(2));
  };
  const [parent, setParent] = useState();
  const Parentdetail = async () => {
    enquiriesModal
      .getdetail(parms?.gid)
      .then((responce) => {
        setParent(responce);
        console.log("data-45", responce);
      })
      .then((error) => {
        console.log("error", error);
      });
  };

  const [datalist, setDataList] = useState();
  const getListData = async () => {
    await enquiriesModal
      .parentDetails(parms?.id)
      .then((result) => {
        console.log("g---------", result);

        if (result) {
          setDataList(result?.data);
        }
      })
      .catch((error) => {
        helper.sweetalert.toast(error?.response?.data?.message, "warning");
      });
  };
  useEffect(() => {
    getListData();
    Parentdetail();
  }, []);
  console.log("dd check", parent);
  return (
    <>
      <Container className="pt-7">
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader style={{ height: "80px" }}>
                <h3 className="mb-0">Create Classes</h3>
              </CardHeader>
              <CardBody>
                <Form onSubmit={handleSubmit}>
                  <div className="p-3">
                    <Row>
                      <Col md={4}>
                        <FormGroup>
                          <Label for="state">State</Label>
                          <Input
                            id="state"
                            type="text"
                            onChange={handleChange}
                            readOnly
                            name="state"
                            value={parent?.userData?.parentData?.state}
                          ></Input>
                        </FormGroup>
                      </Col>

                      <Col md={2}>
                        <FormGroup>
                          <Label for="exampleEmail">City</Label>
                          <Input
                            type="text"
                            name="city"
                            onChange={handleChangeCity}
                            readOnly
                            value={parent?.userData?.parentData?.city}
                          ></Input>
                        </FormGroup>
                      </Col>

                      <Col md={6} className="">
                        <FormGroup>
                          <Label for="exampleEmail">Location</Label>
                          <Input
                            id="location"
                            type="text"
                            readOnly
                            name="location"
                            value={parent?.userData?.parentData?.location}
                            onChange={handleInputChange}
                          />
                        </FormGroup>
                      </Col>

                      <Col md={6}>
                        <FormGroup>
                          <Label for="exampleEmail">Select Parent</Label>
                          <Input
                            id="forType"
                            type="select"
                            onChange={handleChangeParents}
                            required
                            name="parent"
                            value={parms?.id}
                            readOnly
                          >
                            <option> Select Parent </option>
                            {parentsList &&
                              parentsList?.map((item, index) => {
                                return (
                                  <option key={index} value={item.mobile}>
                                    {item?.user.first_name}{" "}
                                    {item?.user.last_name} ({item.mobile})
                                  </option>
                                );
                              })}
                          </Input>
                        </FormGroup>
                      </Col>

                      <Col md={6}>
                        <FormGroup>
                          <Label for="exampleEmail">Select Badge</Label>
                          <Input
                            id="forType"
                            type="select"
                            name="badge"
                            onChange={handleselectbadge}
                            required
                          >
                            <option value="driver">Select Badge</option>
                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="3">3</option>
                            <option value="4">4</option>
                          </Input>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={4}>
                        <FormGroup>
                          <Label for="exampleEmail">Class Name</Label>
                          <Input
                            type="text"
                            name="name"
                            placeholder="Enter Class Name"
                            value={formData.name}
                            onChange={handleInputChange}
                            required
                          // invalid
                          />
                        </FormGroup>
                      </Col>

                      <Col md={4}>
                        <FormGroup>
                          <Label for="exampleEmail">Tutor</Label>
                          <Input
                            id="forType"
                            type="select"
                            name="tutor"
                            onChange={handleChangeTutors}
                            required
                            value={parms?.mid}
                            readOnly
                          >
                            <option value="driver">Select Tutors</option>
                            {tutorsList &&
                              tutorsList?.map((item, index) => {
                                return (
                                  <option key={index} value={item.mobile}>
                                    {item?.user.first_name}{" "}
                                    {item?.user.last_name} ({item.mobile})
                                  </option>
                                );
                              })}
                          </Input>
                        </FormGroup>
                      </Col>

                      <Col md={4}>
                        <FormGroup>
                          <Label for="exampleEmail">Class Type</Label>
                          <Input
                            id="forType"
                            name="type"
                            type="text"
                            readOnly
                            value="RuningClass"
                            required
                          ></Input>
                        </FormGroup>
                      </Col>
                    </Row>

                    <Row>
                      <Col md={4}>
                        <FormGroup>
                          <Label for="startTime">Class Start Time</Label>
                          <Input
                            style={{
                              border: "1px solid lightgrey",
                              padding: "6px 10px",
                              borderRadius: "6px",
                            }}
                            type="time"
                            id="startTime"
                            required
                            name="start_time"
                            value={startTime} // Convert to 12-hour format
                            onChange={handleStartTimeChange} // Call handleStartTimeChange function when the time is changed
                          />
                        </FormGroup>
                      </Col>
                      <Col md={4}>
                        <FormGroup>
                          <Label for="endTime">Class End Time</Label>
                          <Input
                            style={{
                              border: "1px solid lightgrey",
                              padding: "6px 10px",
                              borderRadius: "6px",
                            }}
                            type="time"
                            id="endTime"
                            name="end_time"
                            required
                            value={endTime} // Convert to 12-hour format
                            onChange={handleEndTimeChange} // Call handleEndTimeChange function when the time is changed
                          />
                        </FormGroup>
                      </Col>

                      <Col md={4}>
                        <FormGroup>
                          <Label for="total_cycle">Cycle</Label>
                          <Input
                            style={{
                              border: "1px solid lightgrey",
                              padding: "6px 10px",
                              borderRadius: "6px",
                            }}
                            type="number"
                            required

                            placeholder="1, 2, 3 etc"
                            name="total_cycle"
                            value={formData.total_cycle}
                            onChange={handleInputChange}
                          />
                        </FormGroup>
                      </Col>
                    </Row>

                    <Row>
                      <Col md={3}>
                        <FormGroup>
                          <Label for="monthly_fee">Fee Charged monthly</Label>
                          <Input
                            style={{
                              border: "1px solid lightgrey",
                              padding: "6px 10px",
                              borderRadius: "6px",
                            }}
                            type="number"
                            required
                            placeholder="Enter Amount"
                            name="monthly_fee"
                            value={formData.monthly_fee}
                            onChange={handleInputChange}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={3}>
                        <FormGroup>
                          <Label for="monthly_payscale">
                            Tutors's Payscale per Month
                          </Label>
                          <Input
                            style={{
                              border: "1px solid lightgrey",
                              padding: "6px 10px",
                              borderRadius: "6px",
                            }}
                            type="number"
                            required
                            placeholder="Enter Amount"
                            name="monthly_payscale"
                            value={formData.monthly_payscale}
                            onChange={handleInputChange}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={3}>
                        <FormGroup>
                          <Label for="number_of_session">No. of Session</Label>
                          <Input
                            type="number"
                            name="number_of_session"
                            placeholder="Enter Amount"
                            value={formData.number_of_session}
                            onChange={handleInputChange}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={3}>
                        <FormGroup>
                          <Label for="duration">
                            Class Duration (In Minutes)
                          </Label>
                          <Input
                            type="number"
                            name="duration"
                            placeholder="Enter Class Duration"
                            value={formData.duration}
                            onChange={handleInputChange}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={3}>
                        <FormGroup>
                          <Label for="hourly_fee">Fee Charged Hourly</Label>
                          <Input
                            style={{
                              border: "1px solid lightgrey",
                              padding: "6px 10px",
                              borderRadius: "6px",
                            }}
                            type="number"
                            //  placeholder="Enter Amount"
                            required
                            readOnly
                            name="hourly_fee"
                            value={
                              formData.monthly_fee &&
                                formData.number_of_session &&
                                formData.duration
                                ? Math.round(
                                  (formData.monthly_fee /
                                    (formData.number_of_session *
                                      formData.duration)) *
                                  60
                                )
                                : ""
                            }
                            onChange={handleInputChange}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={3}>
                        <FormGroup>
                          <Label for="hourly_payscale">
                            Tutors's Payscale per hour
                          </Label>
                          <Input
                            style={{
                              border: "1px solid lightgrey",
                              padding: "6px 10px",
                              borderRadius: "6px",
                            }}
                            type="number"
                            required
                            readOnly
                            //  placeholder="Enter Amount"
                            name="hourly_payscale"
                            value={
                              formData.monthly_payscale &&
                                formData.number_of_session &&
                                formData.duration
                                ? Math.round(
                                  (formData.monthly_payscale /
                                    (formData.number_of_session *
                                      formData.duration)) *
                                  60
                                )
                                : ""
                            }
                            onChange={handleInputChange}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={3}>
                        <FormGroup>
                          <Label for="margin">Margin</Label>
                          <Input
                            type="text" // Use text type for margin to allow empty string
                            name="margin"
                            value={
                              formData.monthly_fee && formData.monthly_payscale
                                ? formData.monthly_fee -
                                formData.monthly_payscale
                                : ""
                            }
                            readOnly // Make margin input readonly to prevent direct user input
                          />
                        </FormGroup>
                      </Col>

                      <Col md={3}>
                        <FormGroup>
                          <Label for="endTime">Margin %</Label>
                          <Input
                            type="text"
                            name="margin%"
                            value={
                              formData.monthly_fee && formData.monthly_payscale
                                ? Math.round(((formData.monthly_fee - formData.monthly_payscale) / formData.monthly_fee) * 100)
                                : ""
                            }
                            readOnly // Prevent direct user input
                          />
                        </FormGroup>
                      </Col>
                    </Row>

                    {selectedClassType === "RuningClass" && (
                      <>
                        <Row>
                          <Col md={3} className="d-none">
                            <FormGroup>
                              <Label for="discount_price">
                                Discounted Price
                              </Label>
                              <Input
                                type="number"
                                name="discount_price"
                                placeholder="Enter Discount"
                                value="0"
                                onChange={handleInputChange}
                              />
                            </FormGroup>
                          </Col>
                          <Col md={4}>
                            <FormGroup>
                              <Label for="hours">Hours In A Month</Label>

                              <Input
                                type="number"
                                name="hours"
                                readOnly
                                // placeholder="Enter Days"
                                value={
                                  formData.number_of_session && formData.duration
                                    ? (formData.number_of_session * formData.duration) / 60
                                    : ""
                                }
                              />
                              <p>Total Minutes {totalmintes}</p>
                            </FormGroup>
                          </Col>
                          <Col md={3} className="d-none">
                            <FormGroup>
                              <Label for="price_parent">Price Parent</Label>
                              <Input
                                type="number"
                                name="price_parent"
                                placeholder="Enter Amount"
                                value="0"
                                onChange={handleInputChange}
                              />
                            </FormGroup>
                          </Col>
                          <Col md={4}>
                            <Label>Mode</Label>

                            <Input
                              type="select"
                              onChange={handleChangeMode}
                              required
                              name="mode"
                            >
                              <option value="">Select mode</option>
                              <option value="online">online</option>
                              <option value="offline">offline </option>
                            </Input>
                          </Col>
                          <Col md={4}>
                            <FormGroup>
                              <Label for="notes">Notes</Label>
                              <Input
                                id="forType"
                                type="textarea"
                                placeholder="Enter Notes"
                                name="notes"
                                value={formData.notes}
                                onChange={handleInputChange}
                              />
                            </FormGroup>
                          </Col>
                          <Col md={4} style={{ display: "none" }}>
                            <FormGroup>
                              <Label for="price_tutor">Price Tutors</Label>
                              <Input
                                type="hidden"
                                name="price_tutor"
                                placeholder="Enter Amount"
                                value={"999999999"}
                                readOnly
                                onChange={handleInputChange}
                              />
                            </FormGroup>
                          </Col>
                          <Col md={4} style={{ display: "none" }}>
                            <FormGroup>
                              <Label for="session_per_month">
                                Total Session In A Month
                              </Label>
                              <Input
                                type="hidden"
                                name="session_per_month"
                                placeholder="Enter Days"
                                value={"999999999"}
                                readOnly
                                onChange={handleInputChange}
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                      </>
                    )}
                    <Row>

                      <Col md={4} style={{ display: "none" }}>
                        <FormGroup>
                          <Label for="fee_details">Fee Details</Label>
                          <Input
                            id="forType"
                            type="hidden"
                            placeholder="Enter Fee Details"
                            name="fee_details"
                            value={"99999999"}
                            readOnly
                            onChange={handleInputChange}
                          />
                        </FormGroup>
                      </Col>

                    </Row>
                    <Row>
                      {selecttMode === "online" ? (
                        <Col md={12}>
                          <Label> Meet Link (include https)</Label>
                          <Input
                            type="text"
                            placeholder="Enter Meet Link"
                            name="demo_link"
                            value={formData.demo_link}
                            onChange={handleInputChange}
                          />
                        </Col>
                      ) : null}
                      {selectedClassType === "Demo" ? (
                        <Col md={6}>
                          <FormGroup>
                            <Label for="exampleEmail">Assign Reviewer </Label>
                            <Input id="forType" type="select">
                              <option value="">Select Reviewer </option>
                              <option value="saurabh">saurabh</option>
                              <option value="Pawan">Pawan</option>
                            </Input>
                          </FormGroup>
                        </Col>
                      ) : null}
                      '
                    </Row>
                    {selecttMode == "offline" &&
                      <Row>
                        <Col md={12}>
                          <FormGroup>
                            <Label for="address">Address</Label>
                            <Input
                              id="forType"
                              type="textarea"
                              placeholder="Enter Address"
                              name="address"
                              //value={formData.address}
                              onChange={handleInputChange}
                            />
                          </FormGroup>
                        </Col>


                      </Row>
                    }
                    {rowData.map((row, index) => (
                      <div key={index}>
                        <Row className="mt-3">
                          <Col md={12}>
                            {index !== 0 && (
                              <i
                                className="fa-solid fa-xmark"
                                color="danger"
                                onClick={() => deleteRow(index)}
                                style={{
                                  float: "right",
                                  fontSize: "20px",
                                  color: "red",
                                  marginBottom: "20px",
                                }}
                              />
                            )}
                          </Col>
                        </Row>
                        <Row>
                          <Col md={12}>
                            <Label for={`studentSelect${index}`}>Student</Label>
                            <Input
                              id={`studentSelect${index}`}
                              type="select"
                              name="studentsAll"
                              onChange={(e) => handleStudentSelect(e, index)}
                              required
                              value={parseInt(row[0])} // Convert the selected value to a number using parseInt
                            >
                              <option value="">Select Student</option>
                              {studentList &&
                                studentList.map((item, itemIndex) => (
                                  <option key={itemIndex} value={item.id}>
                                    {item?.name}
                                  </option>
                                ))}
                            </Input>
                          </Col>
                        </Row>
                        <Row className="mt-3 ml-2">
                          <Col md={12}>
                            {studentSubjectList &&
                              studentSubjectList?.map(
                                (subjectGroup, subjectIndex) => {
                                  return (
                                    <div key={subjectIndex}>
                                      <Input
                                        type="checkbox"
                                        value={subjectGroup?.id}
                                        onChange={(e) =>
                                          handleSubjectSelect(
                                            e,
                                            index, // pass 'index' instead of 'subjectIndex'
                                            subjectGroup?.id
                                          )
                                        }
                                        checked={rowData[index]?.includes(
                                          subjectGroup.id
                                        )} // Check if subjectGroup.id is in the current row's data
                                      // required
                                      />
                                      {subjectGroup?.data?.map(
                                        (subject, dataIndex) => (
                                          <span
                                            key={dataIndex}
                                            style={{
                                              fontSize: "14px",
                                              fontWeight: "bold",
                                            }}
                                          >
                                            {dataIndex !== 0 && " / "}
                                            {subject?.name}
                                          </span>
                                        )
                                      )}
                                      <br />
                                    </div>
                                  );
                                }
                              )}
                          </Col>
                        </Row>
                      </div>
                    ))}

                    {/* <button onClick={saveToDatabase}>Save to Database</button> */}
                    <Row>
                      <Col md={12} style={{ fontSize: "20px", float: "right" }}>
                        <i
                          className="fa-solid fa-plus"
                          onClick={addRow}
                          style={{
                            float: "right",
                            fontSize: "20px",
                            color: "blue",
                          }}
                        ></i>{" "}
                        {/* Plus icon to add rows */}
                      </Col>
                    </Row>

                    <>
                      <Row>
                        <Col md={4}>
                          {" "}
                          <FormGroup>
                            <Label for="meetingDate">
                              {" "}
                              {selectedClassType === "RuningClass"
                                ? "Class Start Date"
                                : selectedClassType === "Demo"
                                  ? "Demo Date"
                                  : "Date"}
                            </Label>
                            <Input
                              style={{
                                border: "1px solid lightgrey",
                                padding: "6px 10px",
                                borderRadius: "6px",
                              }}
                              type="date"
                              id="meetingDate"

                              placeholder="Select  date"
                              value={meetingDate} // Set the value of the input field to the meetingDate state
                              onChange={handleDateChange} // Call handleDateChange function when the date is changed
                            />
                          </FormGroup>
                        </Col>
                        {/* {selectedClassType === "RuningClass" && ( */}
                        <Col md={8}>
                          <span>Select Week Days</span>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-between",
                            }}
                          >
                            {/* Render each week name with its checkbox */}
                            {weekNames.map((weekName, index) => (
                              <div key={index} style={{ marginTop: "10px" }}>
                                <label htmlFor={weekName}>{weekName}</label>
                                <div
                                // style={{
                                //   display: "flex",
                                //   flexDirection: "row",
                                // }}
                                >
                                  <input
                                    type="checkbox"
                                    id={weekName}
                                    checked={selectedWeeks.includes(weekName)}
                                    onChange={() =>
                                      handleCheckboxChange(weekName)
                                    }
                                    style={{
                                      width: "25px",
                                      height: "20px",
                                      marginLeft: "1px",
                                    }}
                                  />
                                </div>
                              </div>
                            ))}
                            {/* <h3>
                                Selected Week Days: {selectedWeeks.join(", ")}
                              </h3> */}
                          </div>
                        </Col>
                        {/* // )} */}
                      </Row>
                    </>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginTop: "8px",
                      flexDirection: "row",
                    }}
                  >
                    <Button to="/admin/classes" color="danger" tag={Link}>
                      Cancel
                    </Button>
                    {/* 
                      {addsLoadig ? (
                        <Loader color={"blue"} />
                      ) : ( */}
                    <Button
                      color="primary"
                      type="submit"
                      style={{
                        float: "right",
                        marginLeft: "5%",
                        backgroundColor: "#080278",
                        color: "white",
                        border: "none",
                      }}
                    >
                      Save
                    </Button>
                    {/* )} */}
                  </div>
                </Form>
              </CardBody>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default AddClassesbyid;
